import {combineReducers} from 'redux';

import type {ReportRowData, ComparedActivityReportSummary} from 'nutshell-core/types';

import * as actions from './quotes-report-actions';

const defaultState = {
    data: null,
    hasError: false,
    isLoading: true,
    numPages: null,
} as const;

type SummaryState = {
    hasError: boolean;
    isLoading: boolean;
    data: ComparedActivityReportSummary<Array<ReportRowData>> | null | undefined;
    totals: ComparedActivityReportSummary<ReportRowData> | null | undefined;
};
const defaultSummaryState = {
    ...defaultState,
    totals: null,
} as const;

export const summaryReducer = (
    state: SummaryState | null | undefined = defaultSummaryState,
    action: actions.QuotesReportAction
): SummaryState => {
    switch (action.type) {
        case actions.ActionTypes.QUOTES_REPORT_FETCH_SUMMARY_REQUEST:
            // @ts-expect-error
            return {...state, isLoading: true};
        case actions.ActionTypes.QUOTES_REPORT_FETCH_SUMMARY_SUCCESS:
            return {
                ...state,
                data: action.payload.data,
                totals: action.payload.totals,
                isLoading: false,
                hasError: false,
            };
        case actions.ActionTypes.QUOTES_REPORT_FETCH_SUMMARY_FAILURE:
            // @ts-expect-error
            return {...state, isLoading: false, hasError: true};
        default:
            // @ts-expect-error
            return state;
    }
};

export const quotesReportReducer = combineReducers({
    summary: summaryReducer,
});

export type QuotesReportState = {
    summary: SummaryState;
};
